const storeContextKey = {};
const keyControlsContextKey = {};
const themeContextKey = {};

export { storeContextKey, keyControlsContextKey, themeContextKey };
